import { JSX } from "react";
import styles from "./Details.module.css";
import classNames from "classnames";
import { Trans } from "react-i18next";
import { useI18n } from "../../i18n";

type DetailsBaseProps = { summary: string; className?: string; id?: string };

type DetailsConditionalProps =
  | { details?: string; children?: never }
  | { details?: never; children?: React.ReactNode | string };

type DetailsProps = DetailsBaseProps & DetailsConditionalProps;

export const Details = (props: DetailsProps): JSX.Element => {
  const { t } = useI18n();
  const detailsClassname = classNames(styles.details, props.className);
  return (
    <details className={detailsClassname}>
      <summary id={props.id}>
        <span>{props.summary}</span>
      </summary>
      {props.details ? (
        <p>
          <Trans i18nKey={props.details} t={t} />
        </p>
      ) : (
        <div>{props.children}</div>
      )}
    </details>
  );
};
